import { render, staticRenderFns } from "./ComputadoraData.vue?vue&type=template&id=3d1759a3&"
import script from "./ComputadoraData.vue?vue&type=script&lang=js&"
export * from "./ComputadoraData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports